module.exports = __webpack_public_path__ + "img/img_68.26054520.png";